// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";

// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Button,
  Row,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";
import type { TableProps } from "antd/es/table";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { useMediaQuery } from "@mui/material";

// --------------------- Import Styles ---------------------
import { Container } from "./styles";

// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";

// --------------------- Import Hooks ---------------------
import { useBuscarCotas } from "./hooks/useBuscarCotas";

export default function ViewGerenciarCota() {
  // Recupera os valores enviado pela URL (id do apartamento, nome empreendimento e nome apartamento)
  const [queryParams] = useQueryParams({
    aptoId: NumberParam,
    empreendNome: StringParam,
    aptoNome: StringParam,
  });
  const aptoId = queryParams.aptoId;
  const empreendNome = queryParams.empreendNome;
  const aptoNome = queryParams.aptoNome;

  // Definições para mobile
  const isMobile = useMediaQuery("(max-width:600px)");
  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;

  // Armazena o valor da origem do apartamento
  const [cotaId, setCotaId] = useState<number | null>(null);
  // Armazena o valor da origem do apartamento
  const [numeroCota, setNumeroCota] = useState<number | null>(null);

  // Inicializando o filtro
  const [semFiltros, setSemFiltros] = useState(true);

  const [filteredInfo, setFilteredInfo] = useState<{
    numeroCota?: string[] | null;
    origem?: string[] | null;
  }>({
    numeroCota: null,
    origem: null,
  });

  // Verificação de permissaão
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // Busca as cotas do apartamento
  const { cotas, isLoading } = useBuscarCotas(aptoId);

  // UseEffect armazenamento do filtro
  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        numeroCota: novoFiltro.numeroCota ? [novoFiltro.numeroCota] : null,
        origem: novoFiltro.origem ? [novoFiltro.origem] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    // Atualiza o estado filteredInfo com os filtros aplicados nas colunas 'numeroCota' e 'origem'.
    // Caso não haja filtros, o valor será null.
    setFilteredInfo({
      numeroCota: filters.numeroCota as string[] | null,
      origem: filters.origem as string[] | null,
    });

    // Verifica se há algum filtro ativo (numeroCota ou origem) e atualiza o estado semFiltros.
    // Caso não haja filtros, semFiltros será true.
    const hasFilters = Boolean(filters.numeroCota || filters.origem);
    setSemFiltros(!hasFilters);

    // Se houver paginação ativa, armazena o número da página atual no localStorage.
    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades", // Nome da chave no localStorage
        pagination.current.toString() // Salva a página atual como string.
      );
    }
    // Armazena todos os filtros aplicados no localStorage, convertidos para JSON.
    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  // Remove os filtros aplicados
  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({ numeroCota: null, origem: null });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  // Funçao q ativa a remoção dos filtros
  const handleFilter = () => {
    removerFiltros();
  };

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Gerenciar Períodos
      case "1":
        document.location.href = `/gerenciarPeriodos/?cotaId=${cotaId}&&numeroCota=${numeroCota}&&aptoNome=${aptoNome}&&empreendNome=${empreendNome}&&aptoId=${aptoId}`;
        break;
    }
  };

  // Traz as informações  OnClick, cotaId e numero da cota , ao clickar na linha especifica
  const columns = Columns(onClick, setCotaId, setNumeroCota, {
    numeroCota: filteredInfo.numeroCota,
    origem: filteredInfo.origem,
  });

  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : (
        <Container>
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/inicio`}>
                 
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />

                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Gerenciar Cotas do Apartamento {aptoNome}
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "auto",
                marginLeft: isMobile ? 300 : "1580px",
              }}
            >
              {semFiltros ? (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  disabled={true}
                  style={{ marginBottom: 8 }}
                >
                  <FilterAltIcon />
                </Button>
              ) : (
                <Button
                  onClick={handleFilter}
                  type="primary"
                  style={{ marginBottom: 8 }}
                >
                  <FilterAltOffIcon />
                </Button>
              )}
            </div>
            <Col span={isMobile ? 5 : 1}></Col>
            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 20,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 50,
                }}
              >
                <Table
                  columns={columns}
                  dataSource={cotas}
                  onChange={onChange}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
        </Container>
      )}
      ;
    </>
  );
}
